<section class="grid content-container">
  <p-toast></p-toast>
  <section class="content col-12">
    <section class="text-center grid">
      <div class="p-offset-0 col-12 md:col-6 md:col-offset-3">
        <div class="p-card-login">
          <img src="/assets/images/Aline_logo-12.png" alt="Aline" width="200" />
          @if (loginError) {
            <div class="p_field mb-4">
              <p-message severity="error" data-cy="login-message">{{
                loginError
              }}</p-message>
            </div>
          }
          @if (selectActiveOrganizationUnit) {
            <div>
              <div>
                <p-select
                  [name]="'organizationUnit'"
                  [id]="'organizationUnit'"
                  [options]="organizationUnits"
                  [optionLabel]="'name'"
                  [optionValue]="'id'"
                  [(ngModel)]="selectedOrganizationUnit"
                  placeholder="{{
                    'common.select-organization-unit' | translate
                  }}"
                  data-cy="organization-unit-select"
                ></p-select>
              </div>
            </div>
            <div class="mt-2">
              <button
                pButton
                [type]="'button'"
                (click)="selectOrganization()"
                [disabled]="!selectedOrganizationUnit"
                data-cy="organization-unit-select-button"
              >
                Select
              </button>
            </div>
          } @else {
            <form [formGroup]="loginForm" (ngSubmit)="doLogin()">
              <div class="field">
                <div>
                  <input
                    id="username"
                    data-cy="username"
                    type="text"
                    pInputText
                    formControlName="username"
                    placeholder="{{ 'common.email' | translate }}"
                    class="col-9"
                  />
                </div>
              </div>
              <div class="field">
                <div>
                  <input
                    id="password"
                    type="password"
                    data-cy="password"
                    pInputText
                    formControlName="password"
                    placeholder="{{ 'common.password.password' | translate }}"
                    class="col-9"
                  />
                </div>
              </div>
              <div class="field">
                <button
                  pButton
                  [type]="'submit'"
                  [disabled]="!loginForm.valid"
                  data-cy="login-submit"
                >
                  {{ 'common.button.login' | translate }}
                </button>
              </div>
            </form>
          }
          <app-footer></app-footer>
        </div>
      </div>
    </section>
  </section>
</section>
